module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-57x57-189cbb86879bd526e26a0c196127a544.png";